<template>
    <div>
        <login-form
            v-if="login"
            v-model="login"
            :loginSocial="loginSocial"
            :hubHash="hubHash"
            @forgotPassword="onForgotPassword"
            @openRegister="onRegister()"
            :page="page"
        >
        </login-form>
        <forgot-password v-if="forgot" v-model="forgot" @close="login=true" :page="page"></forgot-password>
    </div>
</template>

<script>
import BaseButton from './../argon/components/BaseButton';

import LoginButton from './Common/LoginButton'
import LoginForm from './Auth/LoginForm';
import ForgotPassword from './Auth/ForgotPassword';

export default {
    name: 'Home',
    props: {
        loginSocial: Array,
        hubHash: String,
        page: Boolean
    },
    components: {
        LoginForm,
        ForgotPassword,
        BaseButton,
        LoginButton
    },
    data() {
        return {
            login: true,
            forgot: false,
            register: false
        }
    },
    mounted() {
        this.$store.subscribe((mutation, state) => {
            if(mutation.type === 'DIALOG_SHOW') {
                return this.login = state.login.status
            }
        })
    },
    watch: {
        register(value) {
            this.login = false
            this.$store.commit('DIALOG_HIDE')
        }
    },
    methods: {
        onForgotPassword() {
            this.login = false;
            this.forgot = true;
            this.$store.commit('DIALOG_HIDE')
        },
        onRegister() {
            return location.href = '/register'
        }
    }
}
</script>

<style>

</style>
